export function currencyCodeToSymbol(code) {
  switch (code) {
    case 'USD':
      return '$';
    case 'GBP':
      return '£';
  }
}
